import React from "react"
import { useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { usePortalPosition } from 'app/@hooks'

function useOutsideAlerter(ref, setOpen) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, setOpen])
}

export default function OutsideAlerter({ parentRef, placement = 'top', align = 'end', modalWidth = 250, modalHeight = 150, offsetTop, ...props }) {
    const wrapperRef = useRef(null)
    useOutsideAlerter(wrapperRef, props.setOpen)
    
    const position = usePortalPosition(parentRef, { placement, align, modalWidth, modalHeight, offsetTop })

    const content = (
        <div 
            className="container-outsider" 
            ref={wrapperRef}
            style={{
                position: 'fixed',
                top: `${position.top}px`,
                left: `${position.left}px`,
                zIndex: 9999,
                minWidth: `${modalWidth}px`,
                maxWidth: `${modalWidth}px`,
                ...props?.containerStyles
            }}
        >
            {props.children}
        </div>
    )

    return createPortal(content, document.body)
}